import React from 'react';
import P from 'prop-types';
import cx from 'classnames';
import { ErrorMessage } from 'formik';

import './ErrorMsg.scss';

const ErrorMsg = ({ className, name, component, render }) => {
  return (
    <ErrorMessage
      className={cx('ErrorMsg', { className })}
      name={name}
      component={component}
      render={render}
    />
  );
};

ErrorMsg.propTypes = {
  className: P.string,
  name: P.string.isRequired,
  component: P.string,
}

ErrorMsg.defaultProps = {
  component: 'div',
};

export default ErrorMsg;
